export default "__VITE_ASSET__Cho5jQg$__"